
import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { Toaster } from "@/components/ui/toaster";
import { NotificationsProvider } from './contexts/NotificationsContext';
import { UserProvider } from './contexts/UserContext';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from './config/queryClient';
import ErrorBoundary from './components/error/ErrorBoundary';

// Import routes
import authRoutes from './routes/authRoutes';
import energyRoutes from './routes/energyRoutes';
import gasRoutes from './routes/gasRoutes';
import waterRoutes from './routes/waterRoutes';
import NotFound from './pages/NotFound';

// Import sustainability dashboard
import SustainabilityDashboardPage from './pages/sustainability/Dashboard';

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <UserProvider>
        <NotificationsProvider>
          <ErrorBoundary>
            <Router>
              <Suspense fallback={
                <div className="flex items-center justify-center h-screen">
                  <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
                </div>
              }>
                <Routes>
                  {authRoutes}
                  {energyRoutes}
                  {gasRoutes}
                  {waterRoutes}
                  <Route path="/sustainability/dashboard" element={<SustainabilityDashboardPage />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Suspense>
              <Toaster />
            </Router>
          </ErrorBoundary>
        </NotificationsProvider>
      </UserProvider>
    </QueryClientProvider>
  );
}

export default App;
